
import type { CarrierObj } from '#/locale';
import type { SegmentItemAo } from '@/apis/flights/model';
import type { FlightDetailCarrierVo, FlightDetailCityVo, FlightRuleVo, SegmentShowItem } from '@/logic/flights/model';

export class BookingTopInfo {
	orderNo: string = '';
	orderId: number = 0;
	orderStatus: number = 0;
	orderPnr: string = '';
	currency: string = '';
	orderPrice: number = 0;
	originOrderPrice: number = 0;
	constructor () {
	}
}
export class ContactInfo {
	name: string = '';
	email: string = '';
	mobile: string = '';
	mobileTel: string = '';
	constructor () {
	}
}
// 航班的人数以及价格
export class FlightPriceInfo {
	adultNum: number = 0;
	childNum: number = 0;
	infantNum: number = 0;
	studentNum: number = 0;
	laborNum: number = 0;
	seamanNum: number = 0;
	adultPrice: number = 0;
	originAdultPrice: number = 0;
	adultTax: number = 0;
	childPrice: number = 0;
	childTax: number = 0;
	infantPrice: number = 0;
	infantTax: number = 0;
	studentPrice: number = 0;
	studentTax: number = 0;
	laborPrice: number = 0;
	laborTax: number = 0;
	seamanPrice: number = 0;
	seamanTax: number = 0;
	originOrderTicketPrice: number = 0;
	orderTicketPrice: number = 0;  //订单的航班总票面价
	orderTaxPrice: number = 0;//订单的航班总税价
	payTotalPrice: number = 0;  //订单总价原币种
	payCurrency: string = '';
	payCommissionWithTotalPrice: number = 0;
	originPayCommissionWithTotalPrice: number = 0;
	commission: string = '0';
	sellLuggage: boolean = false;
	constructor () {
	}
}
// 支付信息
export class PaymentInformation {
	paytime: string = '';
	channelName: string = '';
	currency: string = '';
	price: number = 0;
	commission: string = '0';
	constructor () {
	}
}
export interface FlightArr {
	arrTime: string;
	carrier: string;
	carrierName: string;
	depTime: string;
	flightFromCity: string;
	flightFromCityCn: string;
	flightFromCityCode: string;
	flightFromCityEn: string;
	flightFromCityHk: string;
	flightFromCityJa: string;
	flightFromCityKo: string;
	flightNumber: string;
	flightToCityCn: string;
	flightToCityCode: string;
	flightToCityEn: string;
	flightToCityHk: string;
	flightToCityJa: string;
	flightToCityKo: string;
}
export interface RangeArr {
	arriveDate: string;
	[key: string]: string | FlightArr[] | number;
	fromCityCn: string;
	fromCityCode: string;
	fromCityEn: string;
	fromCityHk: string;
	fromCityJa: string;
	fromCityKo: string;
	rangeId: number;
	startDate: string;
	toCityCn: string;
	toCityCode: string;
	toCityEn: string;
	toCityHk: string;
	toCityJa: string;
	toCityKo: string;
	vtype: number;
}
interface FromCarrierObj {
	[key: string]: string | number;
}
export interface OrderListObj {
	[x: string]: any;
	id: number;
	orderNo: string;
	pnr: string;
	orderStatus: string;
	fromCarrierObj: FromCarrierObj;
	currency: string;
	amount: number;
	airlineName: string;
	fromCityName: string;
	status: number;
	range: RangeArr[];
	carrierObj: CarrierObj;
	payCurrency: string;
	payTotalPrice: number;
}
export interface AuxBaggeInfo4FrontObjLo {
	saleCurrency: string;
	salePrice: string;
	baggageAllowance: string;
	baggagePieces: number;
	tripType: number;
}
export interface PassengerLo {
	id: number;
	ageType: string;
	birthday: string;
	gender: string;
	familyName: string;
	middleName?: string;
	givenName: string;
	cardType: string;
	cardTypeName: string;
	cardNum: string;
	cardIssuePlace: string;
	cardExpired: string;
	nationality: string;
	mobile: string;
	airlineCode: string;
	airlineCardNo: string;
	ticketNo: string;
	passengerId: string;
	auxBaggeInfo4FrontList: AuxBaggeInfo4FrontObjLo[];
}
// 辅营
export interface PassengerExtraLo {
	id: number;
	name: string;
	saleCurrency: string;
	singleExtraTotalPrice: number;
}
export interface PayChannelsLo {
	amountWithCommission: number;
	name?: string;
	channel_name?: string;
	commission: number;
	currency: string;
	icon: string;
	id: number;
	processMode?: number;
	min_amount?: number;
	max_amount?: number;
	type?: number;
	sort?: number;
}
// 通道需要的数据
export interface PayChannelListObj {
	amount: number;
	currency: string;
	no?: string;
	payChannels: PayChannelsLo[];
}
// 支付方式组件
export class PayMethodsClass {
	payCurrency: string = '';
	payAmount: number = 0;
	processMode: number = 0;
	newWindow: any = null;
	orderNo: string = '';
	orderId: string = '';
	defaultPayFazId: number = -1;
	defaultCurrency: string = '';
	constructor () {

	}
	changeOrderIdAndOrderNo(orderNo: string, orderId: string) {
		this.orderNo = orderNo;
		this.orderId = orderId;
	}
	changeNewWindow(newWindow: any) {
		this.newWindow = newWindow;
	}
	changeProcessMode(processMode: number) {
		this.processMode = processMode;
	}
	changeCurrencyAndAmount(payCurrency: string, payAmount: number) {
		this.payCurrency = payCurrency;
		this.payAmount = payAmount;
	}
	changePayFazId(defaultPayFazId: number) {
		this.defaultPayFazId = defaultPayFazId;
	}
	changePayFazCurrency(defaultCurrency: string) {
		this.defaultCurrency = defaultCurrency;
	}
}
export interface PaymentGetUrlParams {
	fazId: number;
	cid: string;
	currency: string;
	orderId: number;
	belongArea: string;
	email: string;
	amount: number;
	payInfo?: string;
	deviceId?: string;
}

export class OrderFlightDetailVo {
	sessionId: string = '';
	arrDate: string = '';
	arrTime: string = '';
	depDate: string = '';
	depTime: string = '';
	duration: number = 0;
	durationFrom: number = 0;
	durationRet: number = 0;
	data: string = '';
	currency: string = '';
	adultPrice: number = 0;
	adultTax: number = 0;
	childPrice: number = 0;
	childTax: number = 0;
	infantPrice: number = 0;
	infantTax: number = 0;
	showFromDuration: string = '';
	showFromHour: number = 0;
	showPrice: number = 0;
	showRetDuration: number = 0;
	showRetHour: number = 0;
	// rule: FlightRuleVo;
	constructor () {
	}
}
export class FlightDetailCityInfoVo extends OrderFlightDetailVo {
	arrCityInfo: FlightDetailCityVo;
	carriers: FlightDetailCarrierVo[];
	carriersFrom: FlightDetailCarrierVo[];
	carriersRet: FlightDetailCarrierVo[];
	depCityInfo: FlightDetailCityVo;
	rule: FlightRuleVo;
	fromSegments: SegmentItemAo[];
	retSegments: SegmentItemAo[];
	showFromSegmentArray: SegmentShowItem[];
	showRetSegmentArray: SegmentShowItem[];
	constructor () {
		super();
		this.arrCityInfo = {
			airportCode: '',
			airpotNameShow: '',
			checked: false,
			cityCode: '',
			cityNameShow: '',
			countryCode: '',
			countryNameShow: '',
			depMinPrice: 0,
		};
		this.carriers = [];
		this.carriersFrom = [];
		this.carriersRet = [];
		this.depCityInfo = {
			airportCode: '',
			airpotNameShow: '',
			checked: false,
			cityCode: '',
			cityNameShow: '',
			countryCode: '',
			countryNameShow: '',
			depMinPrice: 0,
		};
		this.rule = {
		};
		this.fromSegments = [];
		this.retSegments = [];
		this.showFromSegmentArray = [];
		this.showRetSegmentArray = [];
	}
}
